import { injectable } from 'inversify';
import { useAppSelector } from '../../../state/hooks';
import {
  ConneqtRepository,
  PlayerRepository,
} from '../../../state/reduxRepositories';
import { AddConneqtView } from './addConneqt.view.service';
import { ConneqtPlayerDomain } from '../conneqtPlayer.domain';
import {
  CreateConneqtPayload,
  ViewConneqtPayload,
} from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { AuthService } from '../../../state/helperServices/auth/auth.service';
import { AddConneqtSelectors } from './addConneqt.selectors';
import { SentConneqtDomain } from '../sent/sentConneqt.domain';
import { AllConneqtsDomain } from '../allConneqtRequests/allConneqts.domain';

@injectable()
export class AddConneqtDomain extends AddConneqtSelectors {
  constructor(
    protected playerRepository: PlayerRepository,
    protected addConneqtView: AddConneqtView,
    protected conneqtPlayerDomain: ConneqtPlayerDomain,
    private conneqtRepository: ConneqtRepository,
    private authService: AuthService,
    protected sentConneqtDomain: SentConneqtDomain,
    protected allConneqtsDomain: AllConneqtsDomain,
  ) {
    super(
      playerRepository,
      addConneqtView,
      sentConneqtDomain,
      allConneqtsDomain,
    );
  }

  usePendingConneqtInfoSelector = () => {
    return this.addConneqtView.useViewStateSelector();
  };

  useConneqtWithEmailNotFoundSelector = (): ViewConneqtPayload | undefined => {
    return useAppSelector(this.conneqtWithEmailNotFoundSelector);
  };

  usePendingConneqtSelector = (): boolean => {
    return useAppSelector(this.pendingConneqtSelector);
  };

  useAlreadyConneqtedSelector = (): boolean => {
    return useAppSelector(this.alreadyConneqtedSelector);
  };

  useSelectedPlayerClues = () => {
    return useAppSelector(this.selectedPlayerCluesSelector);
  };

  useUserSelector = () => {
    return this.authService.useLoggedInUserSelector();
  };

  // DISPATCH
  dispatchCreateConneqt = (createConneqtPayload: CreateConneqtPayload) => {
    this.conneqtRepository.dispatchCreate(createConneqtPayload);
  };

  dispatchInviteSentStatus = (id: string) => {
    this.conneqtPlayerDomain.dispatchInviteSentStatus(id);
  };

  dispatchSelectedPlayerId = (selectedPlayerId: string) => {
    this.addConneqtView.dispatchViewState({
      selectedPlayerId,
    });
  };

  dispatchResponseEmail = (responseEmail: string) => {
    this.addConneqtView.dispatchViewState({
      responseEmail,
    });
  };
}
